@if (!onboardingDismissed) {
  <!-- Spectacular Cyber Get Started Wizard -->
  <div class="cyber-panel cyber-wizard-container" id="get-start-widget">
    <!-- Cyber Header with Icon and Title -->
    <div class="panel-header">
      <div class="panel-icon">
        <i class="fa-solid fa-rocket" aria-hidden="true"></i>
      </div>
      <div class="panel-title-section">
        <h5 class="panel-title">Get started</h5>
        <p class="panel-subtitle">Six steps to set up</p>
      </div>
      <button
        type="button"
        class="btn-cyber btn-cyber-close"
        aria-label="Dismiss onboarding wizard"
        (click)="dismissOnboarding()"
        (keydown.enter)="dismissOnboarding()"
        (keydown.space)="dismissOnboarding()"
      >
        <i class="fa-solid fa-times" aria-hidden="true"></i>
      </button>
    </div>

    <!-- Spectacular Progress Section -->
    <div class="cyber-progress-section">
      <div class="cyber-progress-info">
        <div class="progress-stats">
          <span class="completed-count">{{ getCompletedStepsCount() }}</span>
          <span class="total-separator">/</span>
          <span class="total-count">{{ steps.length }}</span>
          <span class="progress-label">done</span>
        </div>
        <div class="progress-percentage">
          <span class="percentage-value">{{ progress }}%</span>
        </div>
      </div>

      <!-- Cyber Progress Bar -->
      <div
        class="cyber-progress-bar"
        role="progressbar"
        [attr.aria-valuenow]="progress"
        aria-valuemin="0"
        aria-valuemax="100"
        [attr.aria-label]="'Onboarding progress: ' + progress + '% completed'"
        [attr.title]="'Onboarding progress: ' + progress + '% completed'"
      >
        <div class="cyber-progress-fill" [style.width]="getProgressWidth()">
          <div class="progress-shine"></div>
        </div>
      </div>
    </div>

    <!-- Spectacular Steps List -->
    <div class="cyber-steps-container">
      <ol class="cyber-steps-list" role="list">
        @for (step of steps; track step.id; let i = $index) {
          <li
            class="cyber-step-item"
            [class.completed]="step.completed"
            [class.current]="!step.completed && i === progressStep"
          >
            <!-- Step Icon and Status -->
            <div class="step-status">
              <div class="step-icon-wrapper">
                @if (step.completed) {
                  <i
                    class="fa-solid fa-check-circle step-icon completed-icon"
                  ></i>
                } @else {
                  <i [class]="step.icon + ' step-icon pending-icon'"></i>
                }
              </div>
              <div
                class="step-connector"
                [class.completed]="i < progressStep - 1"
              ></div>
            </div>

            <!-- Step Content: the whole row is one link to where the step is done -->
            <a
              class="step-content step-link"
              [routerLink]="step.route"
              [fragment]="step.fragment"
              (click)="onStepLink(i)"
              [attr.aria-label]="step.title + (step.completed ? ', done' : '')"
            >
              <span class="step-header">
                <span class="step-title" [class.completed]="step.completed">{{ step.title }}</span>
                @if (step.completed) {
                  <span class="step-badge completed-badge" aria-hidden="true">
                    <i class="fa-solid fa-check"></i>
                    <span>Done</span>
                  </span>
                } @else {
                  <i class="fa-solid fa-arrow-right step-go" aria-hidden="true"></i>
                }
              </span>
              @if (!step.completed) {
                <span class="step-description">{{ step.description }}</span>
              }
            </a>
          </li>
        }
      </ol>
    </div>

    <!-- Spectacular Footer Actions -->
    <div class="cyber-wizard-footer">
      <button
        class="btn-cyber btn-cyber-secondary btn-dismiss"
        (click)="dismissOnboarding()"
        (keydown.enter)="dismissOnboarding()"
        (keydown.space)="dismissOnboarding()"
      >
        <i class="fa-solid fa-eye-slash"></i>
        <span>Dismiss checklist</span>
      </button>
    </div>
  </div>
}
